export default __webpack_public_path__ + "static/social-mapa-099c2149e6fd6b495d72619ee2c97a84.png";